import type { QueryClient } from "@tanstack/react-query";
import { Outlet, createRootRouteWithContext } from "@tanstack/react-router";
import type { User } from "firebase/auth";
import type { AuthStatus } from "@/auth/AuthProvider";
import type { Role } from "@/auth/roles";

export type RouterContext = {
  queryClient: QueryClient;
  auth: {
    user: User | null;
    status: AuthStatus;
    role: Role | null;
  };
};

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
});

function RootComponent() {
  return <Outlet />;
}
